/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import { Description, DivRelative, SubTitle } from '../../components/layouts';
import { buildImageURL, clamp } from '../../helpers';
import './style.scss';
import { AnimatePresence } from 'framer-motion';
import { motion } from "../../Motion-polyfill";
import { Link } from '../../components/layouts';
// import LazyLoad from 'react-lazyload';


const TITLES = {
  1: '超级夜景',
  2: '超广角夜景',
  3: '全景夜景'
};

const variants_title = {
  enter: {
    opacity: 0,
    y: 20
  },
  center: {
    opacity: 1,
    y: 0
  },
  exit: {
    opacity: 0,
    y: -20
  }
};
const variants_title_sub = {
  visible: {
    opacity: 1,
    y: 0
  },
  hidden: {
    opacity: 0,
    y: 20
  }
};

export function DesktopContent({ step }) {
  const titleStep = useMemo(() => {
    return clamp(1, step, 3);
  }, [step]);
  return (
    <div className="section-content center">
      <DivRelative className="center">
        <AnimatePresence>
          <motion.div
            className="title-wrapper"
            key={titleStep}
            variants={variants_title}
            initial="enter"
            animate="center"
            exit="exit"
            transition={{
              opacity: { duration: 0.5 },
              y: { duration: 0.5 }
            }}
          >
            <SubTitle>{TITLES[titleStep]}</SubTitle>
          </motion.div>
          <motion.div
            className="title-sub-wrapper"
            animate={titleStep === 3 ? 'visible' : 'hidden'}
            variants={variants_title_sub}
            transition={{
              opacity: { delay: titleStep === 3 ? 0.5 : 0, duration: 0.5 },
              y: { delay: titleStep === 3 ? 0.5 : 0, duration: 0.5 }
            }}
          >
            <SubTitle>目光所及，打包全有</SubTitle>
          </motion.div>
        </AnimatePresence>
      </DivRelative>
      <motion.div
        className="desc"
        animate={titleStep === 3 ? 'visible' : 'hidden'}
        variants={variants_title_sub}
        transition={{
          opacity: { delay: titleStep === 3 ? 0.5 : 0, duration: 0.5 },
          y: { delay: titleStep === 3 ? 0.5 : 0, duration: 0.5 }
        }}
      >
        <Description>
          114° 的超广角微云台拍摄，也可轻松创作夜景风光大片，一镜到手。
          <br/>
          广角还不够？全景夜景奉上。
        </Description>
        <Link bordered={false} href="https://shop.vivo.com.cn/product/10006689" text="购买我的 X60t Pro+" position={10} />
      </motion.div>
    </div>
  );
}
const variants_image = {
  step1: {
    width: '50%',
    paddingBottom: '30%'
  },
  step2: {
    width: '75%',
    paddingBottom: '30%'
  },
  step3: {
    width: '100%',
    paddingBottom: '36.25%'
  }
};


const isWebp = document.querySelector('html').classList.contains('webpSupport');

const IMAGE = isWebp ? buildImageURL('/s10-bg.webp') : buildImageURL('/s10-bg.jpg');

export function DesktopImage({ step }) {
  const imageStep = useMemo(() => {
    return clamp(1, step, 3);
  }, [step]);
  return (
    <div className="superlens-image">
        <motion.div
          className="superlens-view-port lazyBackground"
          animate={`step${imageStep}`}
          variants={variants_image}
          transition={{
            width: { duration: 0.5 },
            paddingBottom: { duration: 0.5 }
          }}
          style={{
            backgroundImage: `url(${IMAGE})`
          }}
        />
    </div>
  );
}
